<!-- @format -->

<template>
	<div id="add-proxy-participant" class="custom-modal">
		<transition name="el-fade-in" mode="out-in">
    <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
			<el-row v-else key="content-loading">
				<div class="modal-body">
					<el-col :span="24">
						<div class="registration-question">
							<div class="sub-title">{{ $t('contentManagement.files.fileAddUpdate.reason') }} <span>*</span></div>
							<el-input v-model="form.reason" :placeholder="'...'" :class="$inputError('reason',validationErrors)" @clear="form.reason = null" clearable></el-input>
              <span class="text-danger" v-if="validationErrors.some(x => x.key == 'reason')">{{ $errorMessage('reason', validationErrors)}}</span>
						</div>
						<RecursiveQuestionBuilder
							v-for="(question, index) in availableQuestions.filter((x) => x.parentQuestionId == null && x.parentAnswerId == null)"
							:key="question.id +'-' + index"
							:question="question"
							:allQuestions="questionItems"
							:availableQuestions="availableQuestions"
							baseValidationKey="questions-"
							:registrationForm="registrationForm"
						/>
					</el-col>
				</div>
			</el-row>
		</transition>

		<div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
			<div class="left-buttons">
				<el-button @click="$emit('closeDialog')">{{ $t('contentManagement.files.fileAddUpdate.close') }}</el-button>
			</div>
			<div class="right-buttons">
				<el-button type="primary" :loading="loading == 'saveLoading'" :disabbled="loading == 'saveLoading'" @click="save">{{ $t('contentManagement.files.fileAddUpdate.save') }}</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import RecursiveQuestionBuilder from '../Questions.vue'

	export default {
		components: {
			RecursiveQuestionBuilder,
		},
		props: ['participantId', 'registrationFormId','registrationForm'],
		data() {
			return {
				form: {
					id: null,
					registrationInputs: [],
					reason: null,
				},
				loading: false,
				availableQuestions: [],
				questionItems: [],
				timeout: null,
			}
		},
    computed :{
         validationErrors(){
            return this.$store.getters.getParticipantValidation;
        },
    },
		methods: {
			async save() {
				this.form.registrationInputs = JSON.parse(JSON.stringify(this.availableQuestions))
				this.form.registrationInputs.forEach((p) => {
					if (p.answer != null) {
						p.answer = p.answer.toString()
					}
				})

        this.loading = 'saveLoading';
        if(this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {

					var res = await this.$store.dispatch('addProxyParticipant', this.form);
          if(!res.data.alert.hasError){
            this.$store.commit('setParticipantValidationErrors', [])
            this.$emit('refresh');
            this.$emit('closeDialog');
          }
          this.loading = false
        }, 500);
			},
		},
		async created() {
      this.$store.commit('setParticipantValidationErrors', [])
			this.loading = 'updateScreenLoading'
			if (this.timeout != null) clearTimeout(this.timeout)
			this.timeout = setTimeout(async () => {
				var res = await this.$store.dispatch('getQuestionsObject', { id: this.registrationFormId, type: 0 })
				this.questionItems = res.data.data.items
				this.availableQuestions = this.questionItems.filter((x) => x.parentQuestionId == null && x.parentAnswerId == null && x.isActive == true)
				this.form.id = this.participantId
				this.loading = false
			}, 500)
		},
	}
</script>

<style lang="less" scoped>
	@danger-color: #ff6565;

	.registration-question {
		.sub-title {
			color: #292f3b;
			font-weight: 500;
			margin-bottom: 8px;
			font-size: 14px;

			span {
				color: @danger-color;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/participants/ParticipantDetails/AddProxy.vue